<template>
  <base-card>
    <div class="tw-text-xl tw-font-thin ">Labels</div>
    <div class="tw-mb-3 tw-text-sm tw-text-gray-500">Note that all labels must be saved in lowercase</div>
    <base-list-group>
      <base-list-item :show-bottom-border="false">
        <div class="tw-font-normal">Customer</div>
        <base-form ref="customerForm" v-model="isCustomerValid">
          <div class="tw-mt-2 tw-grid tw-grid-cols-1 sm:tw-grid-cols-2 tw-gap-4">
            <base-text-field label="Singular" placeholder="Enter singular label" required :value="customerSingular" @input="customerSingular = $event.toLowerCase()" />
            <base-text-field label="Plural" placeholder="Enter plural label" required :value="customerPlural" @input="customerPlural = $event.toLowerCase()" />
          </div>
        </base-form>
        <div class="tw-flex tw-justify-end">
          <base-button @click="updateCustomerLabel" :disabled="!isCustomerValid" :loading="isCustomerLoading">Update</base-button>
        </div>
      </base-list-item>
    </base-list-group>
  </base-card>
</template>

<script>
export default {
  props: {
    businessId: String,
    settings: Array,
  },
  data() {
    return {
      isCustomerValid: true,
      isCustomerLoading: false,
      customerSingular: "",
      customerPlural: "",
    };
  },
  computed: {
    customerSingularSetting() {
      return this.settings.find((s) => s.settingConstant === "CUSTOMER_LABEL_SINGULAR");
    },
    customerPluralSetting() {
      return this.settings.find((s) => s.settingConstant === "CUSTOMER_LABEL_PLURAL");
    },
  },
  methods: {
    async updateCustomerLabel() {
      if (!this.$refs.customerForm.validate()) return;

      let singularTask;
      let pluralTask;

      if (this.customerSingularSetting) {
        singularTask = this.$axios.put(`/businesses/${this.businessId}/settings/${this.customerSingularSetting.businessSettingId}`, {
          ...this.customerSingularSetting,
          stringValue: this.customerSingular,
        });
      } else {
        singularTask = this.$axios.post(`/businesses/${this.businessId}/settings`, {
          settingConstant: "CUSTOMER_LABEL_SINGULAR",
          boolValue: false,
          stringValue: this.customerSingular,
          numValue: 0,
        });
      }

      if (this.customerPluralSetting) {
        pluralTask = this.$axios.put(`/businesses/${this.businessId}/settings/${this.customerPluralSetting.businessSettingId}`, {
          ...this.customerPluralSetting,
          stringValue: this.customerPlural,
        });
      } else {
        pluralTask = this.$axios.post(`/businesses/${this.businessId}/settings`, {
          settingConstant: "CUSTOMER_LABEL_PLURAL",
          boolValue: false,
          stringValue: this.customerPlural,
          numValue: 0,
        });
      }

      try {
        this.isCustomerLoading = true;

        await Promise.all([singularTask, pluralTask]);
        this.EventBus.$emit("GLOBAL_NOTIFY", { title: "Customer Label Saved", message: "The customer label was saved successfully" });
      } finally {
        this.isCustomerLoading = false;
        this.$emit("refresh");
      }
    },
  },
  watch: {
    settings: {
      immediate: true,
      handler() {
        this.customerSingular = this.customerSingularSetting ? this.customerSingularSetting.stringValue : "member";
        this.customerPlural = this.customerPluralSetting ? this.customerPluralSetting.stringValue : "members";
      },
    },
  },
};
</script>
